import styled from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';

import { backgroundColor } from '../ui/utils';

const CallOutArrow = styled.div`
  ${({ display }) => map(display, val => `display: ${val};`)};

  position: absolute;
  width: 40px;
  height: 40px;
  top: calc(100% - 20px);
  left: calc(50% - 20px);
  transform: rotate(45deg);

  ${props => backgroundColor(props.backgroundColor)}

  ${breakpoint('tablet')`
    top: calc(50% - 20px);
    left: unset;
    ${({ position }) => `${position}: calc(100% - 20px)`};
  `};
`;

export default CallOutArrow;
